<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="700px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span>Changelog</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <v-timeline
                align-top
                dense
              >
                <v-timeline-item
                  v-for="(item, index) in items"
                  :key="index"
                  color="primary"
                  small
                >
                  <v-row class="pt-1">
                    <v-col cols="3">
                      <strong>{{ item.version }}</strong>
                    </v-col>
                    <v-col>
                      <strong>{{ item.date }}</strong>
                      <div class="text-caption">
                        {{ item.description }}
                      </div>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Đóng lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapActions } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {}
    },
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        items: [],
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist = false;
        if (this.showDialog) {
          this.dialog = true;
          this.getChangelogs();
        }
      },
      dialog (val) {
        val || this.close();
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      getChangelogs() {
        const app = this;
        app.loading = true;
        axios.get("api/v1/changelogs")
          .then(response => {
            app.items = response.data;
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      }
    }
  }
</script>